import { render } from "./addAccount.vue?vue&type=template&id=300a0023&scoped=true"
import script from "./addAccount.vue?vue&type=script&lang=js"
export * from "./addAccount.vue?vue&type=script&lang=js"

import "./addAccount.vue?vue&type=style&index=0&id=300a0023&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300a0023"]])

export default __exports__